export default "https://cdn-static.gokick.com/assets/f85860d356d81c773b535a0002382fa42e6b6edf/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";